import type { CSSProperties } from 'react';
import type { LinkListsProps } from './types';
import clsx from 'clsx';
import { ContactLinkList } from './ContactLinkList';
import type { CustomerSupportNode } from 'data-layer/src/lib/transformers/types';
import { TextLinkList } from './TextLinkList';

export function TextLinks({ align = 'left', columns = 3, ...props }: LinkListsProps) {
  const customProperties = {
    '--footer-links-list-item-align': align,
  } as CSSProperties;

  return (
    <section className={clsx('footer__links-section', `column-${columns}`)} style={customProperties}>
      <ContactLinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.downloadSoftware}
        type="customer-support"
        variant="text"
        contact={props.contact as CustomerSupportNode}
        device={props.device}
      />
      <TextLinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.services}
        type="services"
        variant="text"
        title={props.constants.i18n_service}
        device={props.device}
      />
      <TextLinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.infos}
        type="information"
        variant="text"
        title={props.constants.i18n_well_informed}
        device={props.device}
      />
      <TextLinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.inspirations}
        type="inspiration"
        variant="text"
        title={props.constants.i18n_product_inspirations}
        device={props.device}
      />
      <TextLinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.about}
        type="about"
        variant="text"
        title={props.constants.i18n_about_pixum}
        device={props.device}
      />
    </section>
  );
}
